import { queryBuilder } from '@innovatrix/utils/dx';

// -- Queries --------------- --- --  -

export const getModelsQuery = queryBuilder(
  {
    fields: {
      _getModels: {
        fields: {
          result: true,
          success: true,
          error: true,
        },
      },
    },
  },
);
